






























import { Component } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  PermisoAccion,
  codigoAccionesMenuItem as Acciones,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColDef,
} from 'ag-grid-community';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import { fetchMS } from '@/pantallas/Conecta/Equipos/fetchMS';
import EquiposFilter from '@/pantallas/Conecta/Equipos/EquiposFilter.vue';
import EquiposEditar from '@/pantallas/Conecta/Equipos/EquiposEditar.vue';
import EquiposActions from '@/pantallas/Conecta/Equipos/EquiposActions.vue';
import EquiposVerDetalle from '@/pantallas/Conecta/Equipos/EquiposVerDetalle.vue';
import { ParamApi } from '@/pantallas/Conecta/Equipos/models/Equipos.model';

@Component({
  components: {
    MantenedorGridSinCodigo,
    EquiposFilter,
    EquiposEditar,
    EquiposActions,
    EquiposVerDetalle,
  },
})
export default class Equipos extends ComponenteBase {
  funcionalidad: Funcionalidades = Funcionalidades.Equipos;

  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  serverSide: any = [];
  data: any = {};
  dataList: any[] = [];
  paramApi: ParamApi = {};

  dialogVerDetalle: boolean = false;
  dialogEditar: boolean = false;

  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: Acciones.accionEditar,
      visible: false,
    },
  ];

  actions() {
    actionsEvent.onVerDetalle(this.handleVerDetalle);
    actionsEvent.onEditar(this.handleEditar);
  }

  ModaVerDetalleCallback(event: any) {
    console.log('ModaVerDetalleCallback', event);
    this.dialogVerDetalle = event;
  }

  constructor() {
    super();
    // Remover las acciones para evitar bucles de notificaciones
    actionsEvent.removeListeners();
    // Volver a llamarlas
    this.actions();

    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 20,
      cacheBlockSize: 20,
      overlayNoRowsTemplate: 'No hay datos disponibles para mostrar',
      onGridReady: this.handleMainGridReady,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
    };
  }

  handleVerDetalle(params: any) {
    this.data = { ...params.data };
    this.dialogVerDetalle = true;
  }

  handleEditar(params: any) {
    this.data = { ...params.data };
    this.dialogEditar = true;
  }

  handleCreate(openModal: boolean) {
    this.dialogEditar = openModal;
  }

  private colsGrid(): ColDef[] {
    const cols = [
      { field: 'Fecha Carga', id: 'fechacarga' },
      { field: 'Número Serie', id: 'serienumero' },
      { field: 'Equipo', id: 'tipoeqname' },
      { field: 'Serie IMEI', id: 'serieimei' },
      { field: 'Series Acitvas', id: 'seriecant_activa' },
      { field: 'Serie Bateria Fecha', id: 'seriebateria_fecha' },
      { field: 'Compra Número', id: 'compranumero' },
      { field: 'Tipo Ubicación', id: 'tipoubicaname' },
      { field: 'Estado INET', id: 'estado_inet' },
      { field: 'Glosa INET', id: 'glosa_inet' },
      { field: 'Estado CRM', id: 'estado_crm' },
      { field: 'Glosa CRM', id: 'glosa_crm' },
      { field: 'Número Carga', id: 'numerocarga' },
      { field: 'Costo Unitario', id: 'costounitario' },
      { field: 'Costo Unitario CLP', id: 'costounitario_clp' },
      { field: 'Costo OC', id: 'costoflete_oc' },
      { field: 'Nuevo Precio Unitario', id: 'nuevoprecio_unitario' },
      { field: 'Factor Importación', id: 'factorimportacion' },
      { field: 'Origen Registro', id: 'origin_registro' },
      { field: 'Nuevo Precio Unitario USD', id: 'nuevoprecio_unitariousd' },
      { field: 'Costo', id: 'idcosto' },
      { field: 'Desinstalado', id: 'desinstalado' },
    ];

    return cols.map(({ field, id }) => {
      let cellRenderer = {};

      if (id === 'estado_inet') {
        cellRenderer = { cellRenderer: this.getHtmlEstadoInet };
      }

      if (id === 'estado_crm') {
        cellRenderer = { cellRenderer: this.getHtmlEstadoCRM };
      }

      if (id === 'desinstalado') {
        cellRenderer = { cellRenderer: this.getHtmlEstadoDesinstalado };
      }

      return {
        headerName: field,
        field: id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        minWidth: 100,
        width: 250,
        ...cellRenderer,
      };
    });
  }

  getHtmlEstadoInet(params: any) {
    const text = params.data.estado_inet === 'true' ? 'Sí' : 'No';
    const color = params.data.estado_inet === 'true' ? '#26FF26' : '#FF2626';
    return `<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: ${color}; border-radius: 50%;"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${text}</a>
    `;
  }

  getHtmlEstadoCRM(params: any) {
    const text = params.data.estado_crm === 'true' ? 'Sí' : 'No';
    const color = params.data.estado_crm === 'true' ? '#26FF26' : '#FF2626';
    return `<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: ${color}; border-radius: 50%;"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${text}</a>
    `;
  }

  getHtmlEstadoDesinstalado(params: any) {
    const text = params.data.desinstalado === 't' ? 'Sí' : 'No';
    const color = params.data.desinstalado === 't' ? '#26FF26' : '#FF2626';
    return `<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: ${color}; border-radius: 50%;"></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${text}</a>
    `;
  }

  handleMainGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridEvent = event;
    const self = this;
    this.serverSide = {
      async getRows(event: any): Promise<void> {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        const serienumero = (self.paramApi.serienumero || '').trim();
        const body = {
          serienumero,
          tipoeqid: self.paramApi.equipo ? self.paramApi.equipo.tipoeqid : '',
          startRow: event.request.startRow,
          fechacarga: self.paramApi.fechacarga ? self.paramApi.fechacarga : '',
          endRow: event.request.endRow,
        };
        try {
          const response = await fetchMS({ body });
          const {
            MENSAJE_RESPUESTA,
            CODIGO_RESPUESTA,
            LISTA,
            TOTAL,
          } = response.data;
          const cod: number = Number(CODIGO_RESPUESTA);
          if (cod !== 1) {
            event.successCallback([{}], 0);
            self.gridApi.showNoRowsOverlay();
            self.dataList = [];
            MENSAJE_RESPUESTA !== 'SIN_DATA' &&
              self.$snotify.error(MENSAJE_RESPUESTA);
            return;
          }
          self.dataList = [...LISTA];
          event.successCallback(LISTA, TOTAL);
        } catch (error) {
          console.error(error instanceof Error ? error.message : error);
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
            { timeout: 3500 }
          );
        }
      },
    };
    this.reloadGrid();
  }

  reloadGrid() {
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  handleFilters(params: any = {}) {
    this.paramApi = { ...params };
    this.reloadGrid();
  }

  handleCloseModal(clean: boolean = false) {
    this.dialogVerDetalle = false;
    this.dialogEditar = false;
    this.loadingService.hideLoading();
    this.data = {};
    clean && this.reloadGrid();
  }
}
